import { Currency } from "../../../../gatsby-theme-pages/__generated__/gatsby.types";

export const getCurrencyFromCountryCode = (countryCode: string): Currency => {
  switch (countryCode) {
    default:
      return "USD";
  }
};
